<template>
    <main-banner
        :title="$t('games.segments_banner_title')"
        players="1 - 4"
        :difficulty="$t('game_difficulty.all')"
        :image="imageSrc"
        id="segments"
        @start-game="selectMatch('Segments')"
        :coming-soon="false"
    />
</template>

<script>
import MainBanner from './Main.vue'
import img from '@images/games/segmentTraining/cardBackground.png'
import { mapStores } from 'pinia'
import { useMatchStore } from '@/stores/match.js'
import { useAuthStore } from '@/stores/auth.js'

export default {
    components: {
        MainBanner,
    },
    props: {
        online: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useMatchStore, useAuthStore),
        imageSrc() {
            return img
        },
    },
    methods: {
        async selectMatch(type) {
            await this.matchStore.selectMatchType(
                type,
                this.authStore,
                this.$router,
                this.$toast,
                this.online,
            )
        },
    },
}
</script>
